/** @format */

import React, { useEffect, useState } from "react";
import styles from "./Main.module.scss";
import SectionTitle from "../../../../components/SectionTitle/SectionTitle";
import Label from "../../../../components/Label/Label";
import labelIcon from "../../../../img/label.svg";
import calendar from "../../../../img/calendar.svg";
import buyPlantsIcon from "../../../../img/nftDesign2.webp";
import tokenNew from "../../../../img/tokenNew.webp";
import AOS from "aos";
import "aos/dist/aos.css";
import Minus from "../../../../img/IconComponents/Minus";
import Plus from "../../../../img/IconComponents/Plus";
import Button from "../../../../components/Button/Button";
import Switcher from "../../../../components/Switcher/Switcher";
import Radio from "../../../../components/Radio/Radio";
import Triangle from "../../../../img/IconComponents/Triangle";
import Loader from "../../../../components/Loader/Loader";
import getRequest from "../../../../helpers/getRequest";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import postRequest from "../../../../helpers/postRequest";
const Main = ({
  amountPlants,
  setAmountPlants,
  sumOfPlants,
  setSumOfPlants,
  enableHarvestSelling,
  setEnableHarvestSelling,
  setPeriodicityHarvestSelling,
  periodicityHarvestSelling,
}) => {
  const [pricePerPlant, setPricePerPlant] = useState(2500);
  const [allowedUserToPay, setAllowedUserToPay] = useState(true);
  // const [isQuestionnaireCompleted, setIsQuestionnaireCompleted] = useState(true)
  const [allowedAmountError, setAllowedAmountError] = useState(null);
  const [loading, setLoading] = useState(true);
  const [isInt, setIsInt] = useState(false);
  const [user, setUser] = useState();

  const { t } = useTranslation();
  const navigate = useNavigate();

  const roundToDecimalPlaces = (num, decimalPlaces) => {
    const multiplier = 10 ** decimalPlaces;
    return Math.round(num * multiplier) / multiplier;
  };

  const upperPlants = () => {
    if (amountPlants === 40) return;
    if (isInt) {
      const result = +amountPlants + 0.1;
      setAmountPlants(roundToDecimalPlaces(result, 1));
    } else {
      setAmountPlants((prev) => prev + 1);
    }
  };

  const lowerPlants = () => {
    if (isInt) {
      if (amountPlants === 0.1) return;
      const result = +amountPlants - 0.1;
      setAmountPlants(roundToDecimalPlaces(result, 1));
    } else {
      if (amountPlants === 1) return;
      setAmountPlants((prev) => prev - 1);
    }
  };

  useEffect(() => {
    setSumOfPlants(+amountPlants * +pricePerPlant);
  }, [amountPlants, pricePerPlant]);

  useEffect(() => {
    AOS.init();
  }, []);

  useEffect(() => {
    setLoading(true);
    getRequest("v1/user/payment-details")
      .then((response) => {
        if (response.data.iban && response.data.bic_swift) {
          setAllowedUserToPay(true);
        } else {
          setAllowedUserToPay(false);
        }
        setLoading(false);
      })
      .catch(() => {
        setLoading(false);
      });
  }, []);

  useEffect(() => {
    async function fetchData() {
      setLoading(true);

      const [whoami, billing] = await Promise.all([
        getRequest("v1/auth/whoami").then((response) => {
          setLoading(false);

          return response;
        }),
        getRequest("v1/user/billing-details").then((res) => {
          return res;
        }),
      ]);

      if (
        billing.data.country !== "Germany" &&
        billing.data.country !== "Deutschland"
      ) {
        setIsInt(true);
        setAmountPlants(0.1);
      }

      if (whoami.status === 200) {
        setUser(whoami.data);
        const forbiddenFractionDectCountries = [
          "Germany",
          "Deutschland",
          "Austria",
          "Österreich",
          "Switzerland",
          "Schweiz",
        ];
        const isFractionAvailable =
          (whoami.data?.advertise_id === "dect" ||
            whoami.data?.advertise_id === "start") &&
          !forbiddenFractionDectCountries.includes(billing.data.country);
        if (whoami.data.advertise_id === "ICO" || isFractionAvailable) {
          setAmountPlants(0.1);
          setIsInt(true);
        }
        if (
          (whoami.data?.advertise_id === "dect" ||
            whoami.data?.advertise_id === "start") &&
          forbiddenFractionDectCountries.includes(billing.data.country)
        ) {
          setAmountPlants(1);
          setIsInt(false);
        }
        // if (whoami.data.is_questionnaire_completed) {
        //   console.log(whoami.data.is_questionnaire_completed)
        //   setIsQuestionnaireCompleted(true)
        // } else {
        //   console.log(whoami.data.is_questionnaire_completed)
        //   setIsQuestionnaireCompleted(false)
        // }
      }
    }

    fetchData();
  }, []);

  const checkIfPossibleToBuy = () => {
    window.gtag("event", "add _to_cart", {
      currency: "EUR",
      purchace_amount: amountPlants * pricePerPlant,
      tokens_amount: amountPlants,
      date: new Date().toISOString(),
      referral_type: user.advertise_id ? "/ad/" + user.advertise_id : null,
    });

    postRequest("v1/orders/is-possible", {
      plants_count: amountPlants,
      total_amount: amountPlants * pricePerPlant,
    })
      .then((response) => {
        if (response.data.isPossible) {
          navigate("/checkout", {
            state: {
              from: window.location.pathname,
            },
          });
        } else {
          setAllowedAmountError(t("You can purchase a maximum of 40 tokens"));
        }
      })
      .catch(() => {
        setLoading(false);
      });
  };


  useEffect(() => {
    setLoading(true);
    getRequest("v1/constants/plant/price")
      .then((response) => {
        setPricePerPlant(response.data);
        setLoading(false);
      })
      .catch(() => {
        setLoading(false);
      });
  }, []);

  return (
    <section className={styles.main}>
      {loading && <Loader />}
      <SectionTitle text={t("Buy Tokens")} />
      <div className={styles.main__wrapper}>
        <div className={styles.main__info}>
          <div className={styles.main__list}>
            <div className={styles.main__list_item}>
              {t("Limited to 180,000 units")}
            </div>
            <div className={styles.main__list_item}>
              {t("Tradable on crypto exchanges")}
            </div>
            <div className={styles.main__list_item}>
              {t("Admission ticket for site visit")}
            </div>
            <div className={styles.main__list_item}>
              {t("Exclusive events and functions")}
            </div>
            <div className={styles.main__list_item}>
              {t("Discounted CBD and cannabis products")}
            </div>
            <div
              className={styles.main__list_item}
              style={{ fontWeight: "bold" }}
            >
              {t("Access to the emission of the planting site NFT")}
            </div>
          </div>
          <div className={styles.main__labels}>
            <div>
              <img
                src={tokenNew}
                alt="buy"
                data-aos="fade-left"
                data-aos-duration="1000"
              />
              <Label
                icon={labelIcon}
                label={t("Current access to NFT 1:")}
                value={`80% ${t("crop yield")}`}
              />
              <img
                src={buyPlantsIcon}
                alt="token"
                data-aos="fade-left"
                data-aos-duration="1000"
                className={styles.miniimg}
              />
            </div>
            {/* <div>
              <img
                src={tokenNew}
                alt="buy"
                data-aos="fade-left"
                data-aos-duration="1000"
              />
              <Label
                icon={calendar}
                label={t("Price per token")}
                value="2.500€"
              />
            </div> */}
          </div>
          <div className={styles.main__list}>
            <div className={styles.main__list_item}>
              {t("4 harvests per year")}
            </div>

            <div className={styles.main__list_item}>
              {t("Harvest yields available in the user area")}
            </div>
            <div className={styles.main__list_item}>
              {t("Unlimited duration")}
            </div>
          </div>
        </div>
      </div>
      <div className={styles.main__action}>
        <div className={styles.main__action_amount}>
          <div className={styles.main__action_setter}>
            <button
              className={styles.main__action_button}
              onClick={() => lowerPlants()}
            >
              <Minus />
            </button>
            <input
              type="number"
              className={styles.main__action_input}
              value={amountPlants}
              onChange={(e) => {
                let newValue = parseFloat(e.target.value);
                if (newValue > 40) {
                  setAmountPlants(40);
                } else {
                  setAmountPlants(newValue);
                }
              }}
            />
            <div className={styles.main__action_text}>
              {amountPlants !== 1 ? t("Tokens") : t("Token")}
            </div>
            <button
              className={styles.main__action_button}
              onClick={() => upperPlants()}
            >
              <Plus />
            </button>
          </div>
          <div className={styles.main__action_noty}>
            <span>{t(`Min. ${isInt ? "0.1" : "1"} Token`)}</span>
            <span>{t("Max. 40 Token")}</span>
          </div>
          <div className={styles.main__action_right}>
            <Button
              text={t("Buy Now")}
              color="buy"
              // disabled={!allowedUserToPay || !isQuestionnaireCompleted}
              disabled={!(amountPlants >= (isInt ? 0.1 : 1) && amountPlants <= 40)}
              onClick={checkIfPossibleToBuy}
            />
            {allowedAmountError && (
              <div className={styles.main__error}>
                <Triangle />
                <div>{t(allowedAmountError)}</div>
              </div>
            )}
            {/* <div className={styles.main__action_switcher}>
            <Switcher
              value={enableHarvestSelling}
              onChange={() => setEnableHarvestSelling((prev) => !prev)}
            />
            <div className={styles.main__action_switcher_text}>
              {t("Enable automated harvest selling")}
            </div>
          </div> */}
            {enableHarvestSelling && (
              <div className={styles.main__radio_container}>
                <Radio
                  value={periodicityHarvestSelling === 4 ? true : false}
                  onChange={() => setPeriodicityHarvestSelling(4)}
                  text={t("4 times per year")}
                />
                <Radio
                  value={periodicityHarvestSelling === 1 ? true : false}
                  onChange={() => setPeriodicityHarvestSelling(1)}
                  text={t("at the end of the year")}
                />
              </div>
            )}
          </div>
        </div>
        <div className={styles.main__action_total}>
          <div className={styles.main__action_total_label}>{t("Total:")}</div>
          <div className={styles.main__action_total_value}>
            {(Number(sumOfPlants) % 2500 == 0
              ? Number(sumOfPlants)
              : Number(sumOfPlants).toFixed(2)
            )
              .toString()
              .replace(/\B(?=(\d{3})+(?!\d))/g, ".")}
            <span>€</span>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Main;
